import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Titles: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={12}>Почетное звание, ученое звание, ученая степень, награда</Typography>
                    <Typography mb={1} ml={14}>Дата получения</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={2}>Почетное звание</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px" }} 
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={4.3}>Ученое звание</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px"}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={3.7}>Ученая степень</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px"}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={10.4}>Награда</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px"}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={3.3}>Дата получения</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px"}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default Titles;

